import { HttpApiSchema } from "@effect/platform";
import { Context, Effect, Layer, ParseResult, Schema } from "effect";
//
// Environment
//
const StripeEnvironmentSchema = Schema.Literal("live", "test");
const StripeEnvironmentFromStringSchema = Schema.transformOrFail(Schema.String, StripeEnvironmentSchema, {
    encode: (toA, options, ast, toI)=>Effect.succeed(toA),
    decode: (fromA, options, ast, fromI)=>{
        if (fromA === "live") {
            return Effect.succeed("live");
        } else if (fromA === "test") {
            return Effect.succeed("test");
        } else {
            return ParseResult.fail(new ParseResult.Type(ast, fromI, "Invalid stripe environment"));
        }
    },
    strict: true
});
export const StripeEnvironmentParam = HttpApiSchema.param("stripeEnvironment", StripeEnvironmentFromStringSchema);
export class StripeEnvironment extends Context.Tag("@open-revenue/stripe/StripeEnvironment")() {
    static Test = Layer.effect(this, Effect.succeed("test"));
    static Live = Layer.effect(this, Effect.succeed("live"));
    static withEnvironment = (effect, environment)=>effect.pipe(Effect.provideServiceEffect(StripeEnvironment, Effect.succeed(environment)));
}
export const ApplicationId = HttpApiSchema.param("applicationId", Schema.NumberFromString);
export const StripeProductIdParam = HttpApiSchema.param("stripeProductId", Schema.String);
